export const redirectToUniversity = (
  university,
  login = true,
  defaultAction,
  alumni = false
) => {
  switch (university.slug) {
    case "assas":
      window.location.href = login
        ? "https://reseaupro.u-paris2.fr/index.php/user/login?loginCas=cas"
        : "https://reseaupro.u-paris2.fr/index.php/inscription";
      break;
    case "paris-nanterre":
      window.location.href = login
        ? "https://cas.parisnanterre.fr/login?service=https%3A%2F%2Freseaupro.parisnanterre.fr%2Findex.php%2Fuser%2Flogin%3FloginCas%3Dcas"
        : "https://reseaupro.parisnanterre.fr/index.php/inscription";
      break;
    case "sorbonne-nouvelle":
      window.location.href = login
        ? "https://reseaupro.sorbonne-nouvelle.fr"
        : "https://reseaupro.univ-paris3.fr/index.php/inscription";
      break;
    case "upec":
      window.location.href = login
        ? "https://reseaupro.u-pec.fr/index.php/user/login?loginCas=cas"
        : "https://reseaupro.u-pec.fr/index.php/inscription";
      break;
    case "uspn":
      window.location.href = login
        ? "https://cas.univ-paris13.fr/cas/login?service=http%3A%2F%2Freseaupro.univ-paris13.fr%2Findex.php%2Fuser%2Flogin%3FloginCas%3Dcas"
        : "http://reseaupro.univ-paris13.fr/index.php/inscription";
      break;
    case "ant":
      window.location.href = "http://www.univ-ag.fr/";
      break;
    case "pantheon-sorbonne":
      alumni
        ? (window.location.href =
            "https://anciens.univ-paris1.fr/index.php/orientation")
        : (window.location.href = process.env.REACT_APP_SHIBBO_URL_LOGIN);
      break;
    default:
      defaultAction();
      break;
  }
};
